import { useEffect } from 'react';
import { CheckCircle2, AlertTriangle, X } from 'lucide-react';

export type OperationResult = {
  key: string;
  kind: 'success' | 'failure';
  title: string;
  detail?: string;
};

export function OperationResultStack({
  items,
  onDismiss,
}: {
  items: OperationResult[];
  onDismiss: (key: string) => void;
}) {
  useEffect(() => {
    const timers = items
      .filter((it) => it.kind === 'success')
      .map((it) => window.setTimeout(() => onDismiss(it.key), 8000));
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [items, onDismiss]);

  if (items.length === 0) return null;
  return (
    <div className="space-y-2">
      {items.map((r) => (
        <div
          key={r.key}
          className={`flex items-start gap-2 rounded border p-3 text-sm ${
            r.kind === 'success'
              ? 'border-success/30 bg-success/10 text-success'
              : 'border-warning/30 bg-warning/10 text-warning'
          }`}
        >
          {r.kind === 'success' ? (
            <CheckCircle2 size={16} className="mt-0.5 shrink-0" strokeWidth={1.5} />
          ) : (
            <AlertTriangle size={16} className="mt-0.5 shrink-0" strokeWidth={1.5} />
          )}
          <div className="flex-1">
            <div className="font-medium">{r.title}</div>
            {r.detail && (
              <div
                className={`mt-0.5 text-muted-foreground ${
                  r.kind === 'failure' ? 'font-mono text-xs' : ''
                }`}
              >
                {r.detail}
              </div>
            )}
          </div>
          <button
            type="button"
            onClick={() => onDismiss(r.key)}
            className="rounded p-0.5 text-muted-foreground hover:bg-background"
            aria-label="Đóng"
          >
            <X size={14} strokeWidth={1.5} />
          </button>
        </div>
      ))}
    </div>
  );
}
